import { FILTER_TYPES } from 'components/FilterPod';

export const STATUS_BRANCH_OPTIONS = [
  {
    value: 'true',
    label: 'فعال',
  },

  {
    value: 'false',
    label: 'غیرفعال',
  },
];

const filters = () => [
  {
    title: 'شناسه تنخواه گردان',
    label: 'شناسه تنخواه گردان',
    keyName: 'businessId',
    query: 'businessId',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'نام تنخواه گردان',
    label: 'نام تنخواه گردان',
    keyName: 'query',
    query: 'query',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'نام کاربری',
    label: 'نام کاربری',
    keyName: 'username',
    query: 'username',
    id: 3,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'ایمیل',
    label: 'ایمیل',
    keyName: 'email',
    query: 'email',
    id: 4,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr' },
  },
 {
    title: 'مالک',
    label: {
      start: 'نام',
      end: 'نام خانوادگی',
    },
    keyName: 'owner',
    id: {
      start: 'ownerFirstName',
      end: 'ownerLastName',
    },
    query: {
      start: 'ownerFirstName',
      end: 'ownerLastName',
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
      },
      end: {
      },
    },
    typeInput: 'string', // نام و نام خانوادگی
  },
  {
    title: 'وضعیت تنخواه گردان',
    label: 'وضعیت تنخواه گردان',
    keyName: 'branchState',
    query: 'branchState',
    id: 9,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_BRANCH_OPTIONS,
    },
  },

 
];

export default filters;
